import React from 'react'
import logo1 from '../img/UMassAmherst_horiz.png'
import logo2 from '../img/MSU_wordmark_green_print.jpg'
import logo3 from '../img/SIIL LOgo.jpg'
import logo4 from '../img/Horizontal_RGB_600.jpg'
import logo5 from '../img/kansas-state-university-vector-logo.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'


const Footer = () => {
    return (
        <>
            <hr className='mt-5' />
            <div className='mt-10 font-Gill font-bold'>
                <div className=' space-x-7 flex justify-center items-center'>
                    <img src={logo4} className='my-1' style={{ 'height': '140px', 'width': '330px' }} />
                    <img src={logo3} className='my-1' style={{ 'height': '140px' }} />
                    <img src={logo5} className='my-1' style={{ 'height': '140px', 'width': '210px' }} />
                    <img src={logo2} className='my-1' style={{ 'height': '140px', 'width': '320px' }} />
                    <img src={logo1} className='my-1' style={{ 'height': '140px', 'width': '320px' }} />
                </div>
                <div className='bg-[#E6E7E8] h-72 mt-3 flex flex-col justify-center items-center'>
                    <h1 className='font-bold text-4xl'>For technical queries:</h1>
                    <h2 className='font-bold text-3xl'>Remote Sensing in Hydrology and Agriculture Laboratory, Michigan State University </h2>
                    <p className='text-2xl mt-4'>524 S. Shaw Lane East Lansing, MI 48824</p>
                    <div className='flex space-x-3 mt-3 text-2xl'>
                        <FontAwesomeIcon className="h-8 w-8" icon={faPhone} /> <span>: (517) 432-1257</span>
                        <FontAwesomeIcon className="h-8 w-8" icon={faEnvelope} /> <span>: dasnaren@msu.edu</span>

                    </div>

                    <p className='mt-14 flex justify-center items-center'>Website implemented by: JASPL (jaspl.pro@gmail.com)</p>

                </div>
            </div>
        </>

    )
}

export default Footer